

<!-- Section Select active Program / Increment -->
<div class="section">
  <!-- Select Program -->
  <label>Program</label>
  <div class="dropdown">
    <select class="dropdown__select" [(ngModel)]="selectedProgramKey" (change)="onSelectedProgramChanged()">
      <option class="dropdown__item" *ngFor="let program of availablePrograms" [value]="program.id">
        {{program.name}}
      </option>
    </select>
    <div class="dropdown__icon">
      <i class="material-icons">keyboard_arrow_down</i>
    </div>
  </div>

  <!-- Select Program Increment-->
  <label>Program Increment</label>
  <div class="dropdown">
    <select class="dropdown__select" [(ngModel)]="selectedPIKey" [disabled]='!selectedProgramKey' (change)="onSelectedPIChanged()">
      <option class="dropdown__item" *ngFor="let programIncrement of availableProgramIncrements" [value]="programIncrement.id">
        {{programIncrement.name}}
      </option>
    </select>
    <div class="dropdown__icon">
      <i class="material-icons">keyboard_arrow_down</i>
    </div>
  </div>
</div>

<!-- Create Program / Increment-->
<label>Create Program / Increment</label>
<div class="section">
  <button mat-raised-button (click)='openProgramCreationDialog()'>Create new Program</button>
  <button mat-raised-button (click)='addProgramIncrement()' [disabled]='!selectedProgramKey'> Create new PI</button>
</div>

<!-- Edit / Delete Program -->
<label>Edit / Delete Program</label>
<div class="section">
  <div class="dropdown">
    <select class="dropdown__select" [(ngModel)]="programIdToDeleteOrEdit">
      <option class="dropdown__item" *ngFor=" let program of availablePrograms" [value]="program.id">
        {{program.name}}
      </option>
    </select>
    <div class="dropdown__icon">
      <i class="material-icons">keyboard_arrow_down</i>
    </div>
  </div>
  <button mat-raised-button (click)='onDeleteProgram()' [disabled]='!programIdToDeleteOrEdit'>Delete</button>
  <button mat-raised-button (click)='onEditProgram()' [disabled]='!programIdToDeleteOrEdit'>Edit</button>
</div>

<!-- Select Program Increment To Delete-->
<label>Delete Program Increment</label>
<div class="section">
  <div class="dropdown">
    <select class="dropdown__select" [(ngModel)]="programIncrementIdToDelete" [disabled]='!selectedProgramKey'>
      <option class="dropdown__item" *ngFor="let programIncrement of availableProgramIncrements" [value]="programIncrement.id">
        {{programIncrement.name}}
      </option>
    </select>
    <div class="dropdown__icon">
      <i class="material-icons">keyboard_arrow_down</i>
    </div>
  </div>
  <button mat-raised-button (click)='onDelete()' [disabled]='!programIncrementIdToDelete'>Delete</button>
</div>
